angular.module('legal.routes', [
  'ui.router'
]).config(function config($stateProvider) {
  $stateProvider.state('legal', {
    url: '/privacy-policy/:standAlone',
    controller: 'Legal',
    templateUrl: 'components/legal/legal.html'
  });
  $stateProvider.state('terms', {
    url: '/terms-and-conditions/:standAlone',
    controller: 'Legal',
    templateUrl: 'components/legal/terms.html'
  });
})
